<template>
  <div>
    <Form @submit.native.prevent="preventSubmit" inline>
    <FormItem label='创建时间：' prop='dateTime' :label-width='100'>
       <DatePicker type="daterange" placeholder="选择日期" v-model="dateTime" :clearable="false" class="date-time" style="width: 240px"></DatePicker>
    </FormItem>
    <FormItem prop="account" label="关联仓库：" :label-width="90">
        <Input type="text" v-model="querySales.repositoryName"></Input>
    </FormItem>
    <FormItem prop="account" label="单据编号：" :label-width="90">
        <Input type="text" v-model="querySales.consumableSellOrderNo"></Input>
    </FormItem>
    <FormItem prop="account" label="关联城市：" :label-width="100">
          <Input type="text" v-model="querySales.associatedCityName"></Input>
    </FormItem>
    <br>
    <FormItem label="生成状态：" prop="consumableSellState" :label-width="90">
        <Select ref="register" v-model="querySales.consumableSellState" filterable style="width:150px">
        <Option :value="0">全部</Option>
        <Option :value="1">成功</Option>
        <Option :value="2">失败</Option>
        <Option :value="3">申请中</Option>
        </Select>
    </FormItem>
    <FormItem prop="account" label="清洁单号：" :label-width="90">
        <Input type="text" v-model="querySales.cleanOrderNo" style="width:200px;"></Input>
    </FormItem>
    <FormItem>
        <Button type="primary" @click="queryAccountListWithKeyword">查询</Button>
    </FormItem>
    </Form>
    <Content>
      <Table stripe :loading='false' :columns='columns' :data='saleList' :width='1045'></Table>
      <div style="margin:10px;overflow:hidden;">
        <Page show-sizer placement='top' :total='listTotal' :page-size='querySales.pageSize' :current='querySales.page' @on-page-size-change="changePageSize" @on-change="changePage"></Page>
      </div>
    </Content>
    <!-- Modal 查看详情-->
    <Modal v-model="detailModal.display" :loading="true"  ref="detailModal" title="物品详情" width="500">
        <Form @submit.native.prevent="preventSubmit" :model="detailModal" :label-width="170">
           <Card dis-hover :padding='14'>
            <p slot="title">一级类别</p>
            <Row class="rows">
              <Col span='10'>物品名称</Col>
              <Col span='10'>数量</Col>
            </Row>
            <Row class="rows" v-for="(goods,index) in detailModal.detailList" :key="index">
              <Col span='10'>{{goods.goodsName}}</Col>
              <Col span='10'>{{goods.num}}</Col>
            </Row>
          </Card>
        </Form>
        <div slot="footer">
        </div>
    </Modal>
  </div>
</template>

<script>
import Moment from "moment";
import Utils from "../../../utils";
import API from "../../../api";

export default {
  created() {
    this.token = Utils.findFromLocalStorage("vue-token");
    this.env = Utils.findFromLocalStorage("env", "dev");
    this.username = Utils.findFromLocalStorage("vue-username");
  },
  data() {
    return {
      dateTime: [
        Moment().subtract(6, 'day').format('YYYY-MM-DD'),
        Moment().format('YYYY-MM-DD')
      ],
      listTotal: 0,
      saleList: [],
      detailModal:{
        display:false,
        detailList:[]
      },
      querySales: {
        repositoryName: "",
        consumableSellOrderNo: "",
        consumableSellState: 0,
        cleanOrderNo: "",
        page: 1,
        pageSize: 10,
        beginDate:'',
        endDate:'',
        associatedCityName:''
      },
      queryParamSales: {
        repositoryName: "",
        consumableSellOrderNo: "",
        consumableSellState: 0,
        cleanOrderNo: "",
        page: 1,
        pageSize: 10,
        beginDate:'',
        endDate:'',
        associatedCityName:''
      },
      columns: [
        {
          title: "创建时间",
          key: "createDate",
          align: "center",
          width: 130,
          render:(h,p)=>{
            return h(
              'span',
              p.row.createDate ? Moment(p.row.createDate).format("YYYY-MM-DD HH:mm:ss") : ''
            )
          }
        },
        {
          title: "单据编号",
          key: "consumableSellOrderNo",
          align: "center",
          width: 150
        },
        {
          title: "关联城市",
          key: "associatedCityName",
          align: "center",
          width: 140,
        },
        {
          title: "关联仓库",
          key: "repositoryName",
          align: "center",
          width: 150
        },
        {
          title: "销售物品",
          key: "consumableSellOrderId",
          align: "center",
          width: 150,
          render:(h,params)=>{
            return h('div',[
                h('Button',{
                    props:{
                        type:'info',
                        size:'small',
                        disabled: params.row.consumableSellState == 1 ? false : true
                    },
                    on:{
                        click:()=>{
                          this.goodsDetailSale(params.row.consumableSellOrderId)
                        }
                    }
                },
                '查看详情'
                )
            ])
          }
        },
        {
          title: "生成状态",
          key: "consumableSellState",
          align: "center",
          width: 150,
          render:(h,params)=>{
              return h('div',[
                h('Tag',{
                    props:{
                        color:'yellow',
                        size:'small'
                    },
                },
                params.row.consumableSellState == 1 ? '成功' : params.row.consumableSellState == 2 ? '失败':'申请中'),
                h('p',{},params.row.createOrderFailCause == 2 ? params.row.createOrderFailCause : '')
              ]);
          }
        },
        {
          title: "清洁单号",
          key: "cleanOrderNo",
          align: "center",
          width: 170
        }
      ]
    };
  },
  mounted() {
    this.querySalesList();
    this.$Notice.config({
      top: 200
    });
  },
  methods: {
    // 列表数据
    async querySalesList() {
      this.queryParamSales.beginDate = this.dateTime[0] ? Moment(this.dateTime[0]).format('YYYY-MM-DD') : "";
      this.queryParamSales.endDate = this.dateTime[1] ? Moment(this.dateTime[1]).format('YYYY-MM-DD') : "";
      this.queryParamSales.consumableSellState = this.querySales.consumableSellState == 0 ? '' : this.querySales.consumableSellState;
      let resp = (await API.omsAPI[this.env].cleaner.sellListingList(this.queryParamSales,this.token)).data
      if (resp.retCode) {
        this.$Notice.error({
          title: "获取列表失败",
          desc: resp.msg
        });
        return;
      }
      this.saleList = resp.content || [];
      this.listTotal = resp.totalCount
    },
    queryAccountListWithKeyword() {
      this.queryParamSales = Object.assign({}, this.querySales);
      this.querySalesList();
    },
    //查看详情
    async goodsDetailSale(SellOrderId){
        let resp = (await API.omsAPI[this.env].cleaner.sellListingGoodsList({SellOrderId},this.token)).data;
        if (resp.retCode) {
          this.$Notice.error({
            title: "获取数据失败",
            desc: resp.msg
          });
          return;
        }
        this.detailModal.detailList = resp;
        this.detailModal.display = true;
    },
    changePage(pageIndex) {
      this.queryParamSales.page = pageIndex;
      this.querySalesList();
    },
    changePageSize(size) {
      this.queryParamSales.page = 1;
      this.queryParamSales.pageSize = size;
      this.querySalesList();
    },
    preventSubmit() {
      return false;
    }
  }
};
</script>

<style>
.rows{
    height: 25px;
    line-height: 25px;
    background-color: #eee;
    margin-bottom: 1px;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/cleaner/materialCollar-list/material-sales.vue